import { render, staticRenderFns } from "./NotebookSnapshotContainer.vue?vue&type=template&id=c6d82378&"
import script from "./NotebookSnapshotContainer.vue?vue&type=script&lang=js&"
export * from "./NotebookSnapshotContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports